import React, { useContext, useState } from 'react';
import { NextRouter } from 'next/router';

interface IContextValue {
  startReloadTimer: () => void;
  withReloadTimer: (callback: any) => any;
}

const TIMEOUT = 10 * 1000 * 60; // 10분

const ReloadTimerContext = React.createContext<IContextValue>({
  startReloadTimer: () => {},
  withReloadTimer: () => {},
});

function ReloadTimerContextProvider({
  children,
  router,
}: {
  children: React.ReactNode;
  router: NextRouter;
}) {
  const [timeStamp, setTimeStamp] = useState<number | null>(null);
  const startReloadTimer = () => setTimeStamp(Date.now());
  const withReloadTimer =
    (callback: any) =>
    (...arg: any[]) => {
      const current = Date.now();
      if (!timeStamp || current - timeStamp < TIMEOUT) {
        return callback(...arg);
      }
      if (arg[0]?.preventDefault) arg[0].preventDefault();

      const flag = window.confirm(
        '조회시간이 만료되었습니다.\n같은 조건으로 다시 검색하시겠습니까?',
      );
      if (flag) router.reload();
    };

  return (
    <ReloadTimerContext.Provider
      value={{
        startReloadTimer,
        withReloadTimer,
      }}
    >
      {children}
    </ReloadTimerContext.Provider>
  );
}

function useReloadTimerContext() {
  return useContext(ReloadTimerContext);
}

export { ReloadTimerContextProvider, useReloadTimerContext };
